// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3rG6J","insightsList":"newBusinessInsightsMenu_insightsList__lzK1U","active":"newBusinessInsightsMenu_active__3Fepx"};